import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimCheckbox, ClaimTextField } from '../fields';

export const Box31_PhysicianSignature: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">31. SIGNATURE OF PHYSICIAN OR SUPPLIER</Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Controller
          name="physicianSignature.signed"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimCheckbox
              field={field}
              fieldState={fieldState}
              label="SIGNATURE ON FILE"
            />
          )}
        />
        <Controller
          name="physicianSignature.date"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              type="date"
              size="small"
              label="Date"
              InputLabelProps={{ shrink: true }}
            />
          )}
        />
        <Controller
          name="physicianSignature.credentials"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Credentials"
              fullWidth
              disabled
            />
          )}
        />
      </Box>
    </>
  );
};